import React, { useEffect, useState } from "react";
import api, { errMsg } from "../../core/api";
import RecordPage from "../../components/RecordPage";
import Modal from "../../components/Modal";
import { useApp } from "../../core/AppContext";
import { formatDate, todayIso } from "../../core/format";

import { repairPrint } from "../../core/printConfigs";



import EntityFiles, { attachmentsField, mainFromAttachments, afterSaveFor } from "../../components/EntityFiles";
const KINDS = [
  { value: "repair", label: "تعمیرات" },
  { value: "renewal", label: "نوسازی" },
];
const KIND_LABEL = { repair: "تعمیرات", renewal: "نوسازی" };
const STATUS = [
  { value: "pending", label: "در انتظار تأیید" },
  { value: "approved", label: "تأیید شد" },
  { value: "rejected", label: "رد شد" },
];
const STATUS_LABEL = { pending: "در انتظار تأیید", approved: "تأیید شد", rejected: "رد شد" };
const TONE = { pending: "warn", approved: "ok", rejected: "bad" };

function RejectModal({ onClose, onSubmit }) {
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (text.trim().length < 3) return setErr("دلیل رد را بنویسید");
    setBusy(true);
    setErr("");
    try {
      await onSubmit(text.trim());
    } catch (e) {
      setErr(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <Modal small title="رد تعمیرات ثبت‌شده" onClose={() => !busy && onClose()}
      footer={<>
        <button className="btn btn-danger" onClick={go} disabled={busy}>{busy ? "..." : "رد"}</button>
        <button className="btn btn-ghost" onClick={onClose} disabled={busy}>انصراف</button>
      </>}>
      {err && <div className="alert err">{err}</div>}
      <div className="field">
        <label>دلیل رد (برای ثبت‌کننده نمایش داده می‌شود)</label>
        <textarea rows={4} maxLength={500} value={text} onChange={(e) => setText(e.target.value)} />
      </div>
    </Modal>
  );
}

export default function EquipmentRepairs({ onChanged }) {
  const { user, toast, confirm } = useApp();
  const admin = user.role === "admin";
  const staff = user.role === "staff";
  const [equipment, setEquipment] = useState([]);
  const [tick, setTick] = useState(0);
  const [rejectFor, setRejectFor] = useState(null);
const [filesFor, setFilesFor] = useState(null);
  useEffect(() => {
    api.get("/equipment").then((r) => setEquipment(r.data.items)).catch((e) => toast(errMsg(e), "err"));
  }, [toast]);

  const approve = async (r, load) => {
    if (!(await confirm("این تعمیرات تأیید و ثبت نهایی شود؟", { okText: "تأیید", danger: false }))) return;
    try {
      await api.post(`/equipment-repairs/${r.id}/decision`, { approve: true });
      toast("تأیید شد");
      load();
      onChanged?.();
    } catch (e) { toast(errMsg(e), "err"); }
  };

  const reject = async (note) => {
    await api.post(`/equipment-repairs/${rejectFor.row.id}/decision`, { approve: false, note });
    toast("رد شد");
    rejectFor.load();
    setRejectFor(null);
    onChanged?.();
  };

  const badge = (r) => <span className={`badge ${TONE[r.status]}`}>{STATUS_LABEL[r.status]}</span>;

  return (
    <>
      <RecordPage
        key={tick}
         printReport={repairPrint}
        title="تعمیرات و نوسازی تجهیزات"
        subtitle={
          admin ? "ثبت مستقیم، یا تأیید و رد تعمیراتی که کاربران ثبت کرده‌اند"
            : staff ? "تعمیرات ثبت‌شده‌ی شما پس از تأیید مسئول ایمنی نهایی می‌شود"
              : "مشاهده‌ی تعمیرات و نوسازی‌های تأییدشده"
        }
        endpoint="/equipment-repairs"
        createLabel="ثبت تعمیرات / نوسازی"
        multipart
        canCreate={admin || staff}
        canEdit={false}
        canDelete={admin}
        initial={{ kind: "repair", repairDate: todayIso() }}
        filters={[
          { name: "status", label: "وضعیت", options: STATUS },
          { name: "kind", label: "نوع کار", options: KINDS },
        ]}
        columns={[
          { key: "repairDate", label: "تاریخ انجام", render: (r) => formatDate(r.repairDate) },
          { key: "equipmentCode", label: "کد انبار", render: (r) => <b dir="ltr">{r.equipmentCode || "—"}</b> },
          { key: "equipmentName", label: "تجهیزات", render: (r) => <b>{r.equipmentName}</b> },
          { key: "kind", label: "نوع کار", render: (r) => KIND_LABEL[r.kind] },
          { key: "subject", label: "موضوع" },
          { key: "description", label: "شرح انجام‌شده", render: (r) => <div className="clip" title={r.description}>{r.description}</div> },
          { key: "creatorName", label: "ثبت‌کننده" },
          {
            key: "status", label: "وضعیت",
            render: (r) => (
              <div style={{ display: "grid", gap: 4, justifyItems: "start" }}>
                {badge(r)}
                {r.status !== "pending" && r.deciderName && !(r.decidedBy === r.createdBy) && <small className="hint">{r.deciderName}</small>}
                {r.decisionNote && <small className="hint">{r.decisionNote}</small>}
              </div>
            ),
          },

        ]}
        hideFileButton
transformBody={mainFromAttachments}
afterSave={afterSaveFor("repair")}
        getFields={() => [
          {
            name: "equipmentId", label: "تجهیزات", type: "select", required: true, full: true,
            options: equipment.map((e) => ({ value: e.id, label: `${e.code ? `${e.code} — ` : ""}${e.name} — ${e.kind} — ${e.location}` })),
          },
          { name: "kind", label: "نوع کار", type: "select", options: KINDS, required: true },
          { name: "repairDate", label: "تاریخ انجام", type: "date", required: true },
          { name: "subject", label: "موضوع تعمیرات", required: true, full: true },
          { name: "description", label: "شرح تعمیرات انجام‌شده", type: "textarea", required: true, full: true },
          {
            name: "file", label: "فایل / عکس (اختیاری)", type: "file", full: true,
            hint: "PDF یا تصویر (PNG، JPG، WEBP) تا ۵ مگابایت",
          },
          attachmentsField("فایل‌ها / عکس‌ها (اختیاری، چند فایل مجاز است)"),
        ]}
     rowExtra={(r, load) => (
  <>
    <button className="icon-btn" title="فایل‌ها" onClick={() => setFilesFor(r)}><i className="fa-solid fa-folder-open" /></button>
    {admin && r.status === "pending" && (
      <>
        <button className="btn btn-sm" onClick={() => approve(r, load)}><i className="fa-solid fa-check" /> تأیید</button>
        <button className="btn btn-sm btn-danger" onClick={() => setRejectFor({ row: r, load })}><i className="fa-solid fa-xmark" /> رد</button>
      </>
    )}
  </>
)}
      />
      {rejectFor && <RejectModal onClose={() => setRejectFor(null)} onSubmit={reject} />}
        {filesFor && (
  <EntityFiles type="repair" id={filesFor.id} title={filesFor.subject}
    mainPath={filesFor.hasFile ? `/equipment-repairs/${filesFor.id}/file` : null}
    canAdd={admin || (staff && filesFor.createdBy === user.id && filesFor.status === "pending")}
    canRemove={admin || (staff && filesFor.createdBy === user.id && filesFor.status === "pending")}
    onClose={() => setFilesFor(null)} />
)}
    </>
  );
}